import { render } from "./ViewLayout.vue?vue&type=template&id=40723228&scoped=true"
import script from "./ViewLayout.vue?vue&type=script&lang=js"
export * from "./ViewLayout.vue?vue&type=script&lang=js"

import "./ViewLayout.vue?vue&type=style&index=0&id=40723228&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40723228"

export default script